import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { useState } from 'react';
import { useEffect } from 'react';
import { FC } from 'react';
import Actions from "../../Profile/components/Actions";
import { blockMember, complaintAboutMember, getMemberOnlineStatus, getMyMemberDetails, getProfileMember } from "../../../services/memberService";
import { useSelector, useDispatch } from "react-redux";
import { setNeedToRefresh } from "../../../redux/carpet";
import { RootState } from "../../../redux/store";
import NiceModal from '@ebay/nice-modal-react';
import { hideConversation } from "../../../services/messageService";
import { CONVERSTAION } from "../../../navigation/Constants";
import { GenderType } from '../../../helpers/Enums';
import { setUserData } from "../../../redux/member";

export type ChatHaderProps = {
   memberCode: number;
   memberName: string;
   isNavigateFromProfilePage: boolean;
   memberImage: string;
   userName: string;
}


const ChatHeader: FC<ChatHaderProps> = ({ memberCode, memberName, isNavigateFromProfilePage, memberImage, userName }) => {
   const [navigateFromProfile, setNavigateFormProfile] = useState<boolean>(false);
   const [member, setMember] = useState<any>(null);
   const [onlineStatus, setOnlineStatus] = useState<any>()
   let history = useHistory();
   let location = useLocation();
   const dispatch = useDispatch();
   const myMemberCode = useSelector((state: RootState) => state.member.memberCode);

   useEffect(() => {
      if (location && location.state) {
         const { navigateFromProfile }: any = location.state;
         setNavigateFormProfile(navigateFromProfile)
      }
   }, [])

   const fetchData = async () => {
      const { data } = await getProfileMember(myMemberCode, memberCode);
      setMember(data);
   };

   const getStatus = async () => {
      const { data: { isOnline } } = await getMemberOnlineStatus(memberCode);
      setOnlineStatus(isOnline)
   }

   useEffect(() => {
      fetchData();
      getStatus();
   }, [])

   const link = usePrepareLink({
      state: {
         navigateFromProfile: navigateFromProfile,
         memberName: memberName,
      },
      query: {
         [GET_PARAMS.memberCode]: memberCode,
      },
      pushToQuery: {
         [GET_PARAMS.popup]: GET_POPUPS.popup.profile,
      },
      keepOldQuery: true,
   });

   const blockMemberRequest = async () => {
      try {
         history.goBack();
         await blockMember(myMemberCode, memberCode);
         dispatch(setNeedToRefresh(true));
      }
      catch (error: any) {
         NiceModal.hide("action_modal");
         //show something else;
      }

   };

   const hideChat = async () => {
      try {
         await hideConversation(myMemberCode, memberCode);
         const { data } = await getMyMemberDetails(myMemberCode);

         dispatch(setUserData(data));
         // dispatch(setNeedToRefresh(true));
         document.dispatchEvent(new CustomEvent('refresh-conversation-list'));
         history.push(CONVERSTAION);
      } catch (error: any) {
         console.log(error);
      }
   }

   const handleComplaintAboutMember = async (complaintId: number, complaintText: string) => {
      try {
         const request = {
            memberCode: myMemberCode,
            complaintMemberCode: memberCode,
            complaintId,
            complaintText
         };
         await complaintAboutMember(request);
         NiceModal.remove("reportMember_modal");
         history.goBack();

      }
      catch (error) {
         NiceModal.hide("reportMember_modal");
      }
   };

   const onlineStatus1 = {
      marginLeft: '5px',
      marginRight: '5px',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      border: '1px solid gray',
      backgroundColor: 'green'
   }

   const offlineStatus1 = {
      marginLeft: '5px',
      marginRight: '5px',
      width: '10px',
      height: '10px',
      borderRadius: '50%',
      border: '1px solid gray',
      backgroundColor: 'red'
   }

   return (
      <div className="top_content profile">
         <a href="#" onClick={history.goBack} className="top_back w-inline-block">
            <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
         </a>
         <div className="full_prof_info w-clearfix">
            {
               navigateFromProfile ?
                  <a href="#" onClick={history.goBack} className="chat_top_pict w-inline-block">
                     {memberImage && <img src={memberImage} loading="lazy" alt="" className="item_pict" />}
                  </a>
                  :
                  <Link to={link} className="chat_top_pict w-inline-block">
                     {memberImage && <img src={memberImage} loading="lazy" alt="" className="item_pict" />}
                  </Link>
            }
            <div className="user_basic_info" style={{ display: 'flex' }}>
               {
                  navigateFromProfile ?
                     <div onClick={history.goBack}>
                        <h2 className="user_name">{userName}</h2>
                     </div>
                     :
                     <Link to={link} style={{ color: "black" }}>
                        <h2 className="user_name">{userName}</h2>
                     </Link>
               }
               {/* <div style={onlineStatus ? onlineStatus1 : offlineStatus1}></div> */}
               {onlineStatus && <div style={{ fontSize: '1rem', position: 'absolute', bottom: '-13px' }}>{member?.genderId === GenderType.MALE ? 'מחובר' : 'מחוברת'}</div>}
               {
                  (member?.profileIsVerified && member?.hasBeenAuthenticatedByPhone) && <div className="ic_vi" />
               }
            </div>
         </div>

         {/* <div
            data-hover="false"
            data-delay={0}
            className="my_menu w-clearfix w-dropdown"
         >
            <div className="my_menu_button w-dropdown-toggle" />
            <nav className="my_menu_list w-dropdown-list"> */}

         <Actions
            handleBlockMember={blockMemberRequest}
            complaintAboutMember={handleComplaintAboutMember}
            hideChat={hideChat}
            isChatScreen={true}
         />
         {/* </nav>
         </div> */}
      </div>
   )
}

export default ChatHeader;